import { useValidation } from '@eti/providers';
import { Field } from 'redux-form';
import { constants } from '@eti/utils';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import AncillaryToggleBar from './AncillaryToggleBar';
import { jsx as _jsx } from "react/jsx-runtime";
const isFalsy = val => val === null || typeof val === 'undefined' || !val;
const decideSelectedValue = value => !isFalsy(value) ? value : '';
const defaultOption = {
  id: '',
  label: '',
  value: ''
};
const mapPropsToProps = _ref => {
  let {
    input,
    meta,
    options = [defaultOption, defaultOption],
    inputName
  } = _ref;
  return {
    inputName,
    meta,
    onValueChange: input.onChange,
    options,
    selectedValue: decideSelectedValue(input.value)
  };
};
const AncillaryToggleBarComponent = props => /*#__PURE__*/_jsx(AncillaryToggleBar, {
  ...mapPropsToProps(props)
});
const AncillaryToggleBarField = _ref2 => {
  let {
    form,
    formatGet,
    formatSet,
    inputName: ProductName,
    isConfirmationEnabled,
    name,
    options,
    onChange,
    persuasionEnabled,
    priceRaw,
    productPosition,
    rootElement,
    setConfirmationIsOpen,
    setConfirmationOnConfirm,
    setConfirmationOnDecline,
    setPersuasionIsOpen,
    setPersuasionOnConfirm,
    setPersuasionOnDecline,
    size,
    travelers,
    validationRuleName
  } = _ref2;
  const validate = useValidation(validationRuleName);
  const {
    sendAddToCartEvent,
    updateContext
  } = useProductSnowplowTracking(ProductName, {
    rootElement,
    productPosition,
    sendSeenEvent: false
  });
  const handleChange = async (event, newValue, previousValue, field) => {
    const isProductAdded = newValue.value === 'true';
    if (onChange) {
      onChange(event, newValue, previousValue, field);
    }
    const travelersWithoutInfants = travelers.filter(_ref3 => {
      let {
        ageType
      } = _ref3;
      return ageType !== constants.ageTypes.INFANT;
    });
    await updateContext({
      quantity: travelersWithoutInfants.length
    });
    sendAddToCartEvent({
      addToCart: isProductAdded
    });
  };
  return /*#__PURE__*/_jsx(Field, {
    component: AncillaryToggleBarComponent,
    form: form,
    format: formatGet,
    inputName: ProductName,
    isConfirmationEnabled: isConfirmationEnabled,
    name: name,
    normalize: formatSet,
    onChange: handleChange,
    options: options,
    persuasionEnabled: persuasionEnabled,
    priceRaw: priceRaw,
    setConfirmationIsOpen: setConfirmationIsOpen,
    setConfirmationOnConfirm: setConfirmationOnConfirm,
    setConfirmationOnDecline: setConfirmationOnDecline,
    setPersuasionIsOpen: setPersuasionIsOpen,
    setPersuasionOnConfirm: setPersuasionOnConfirm,
    setPersuasionOnDecline: setPersuasionOnDecline,
    size: size,
    validate: validate
  });
};
export default AncillaryToggleBarField;